import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Globe2, Network, Server, Code2 } from 'lucide-react';

const PentestTypes = () => {
  const pentestData = [
    {
      title: "Pentest Web",
      icon: <Globe size={18} />,
      description: "Test de sécurité des applications web afin d'identifier les vulnérabilités exploitables comme les injections SQL ou les failles XSS.",
    },
    {
      title: "Pentest Externe",
      icon: <Globe2 size={18} />,
      description: "Analyse des systèmes accessibles depuis Internet pour détecter les failles exposées et prévenir les intrusions sur votre périmètre externe.",
    },
    {
      title: "Pentest Interne",
      icon: <Server size={18} />,
      description: "Simulation d'une attaque depuis l'intérieur du réseau pour identifier les risques de mouvements latéraux et d'élévation de privilèges.",
    },
    {
      title: "Pentest Active Directory",
      icon: <Network size={18} />,
      description: "Audit de la sécurité de l'infrastructure Active Directory, des configurations GPO et de la gestion des privilèges utilisateurs critiques.",
    },
    {
      title: "Audit Applicatif",
      icon: <Code2 size={18} />,
      description: "Analyse de la sécurité d'applications métier ou plateformes spécifiques, incluant l'audit de code source et la vérification des API.",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { staggerChildren: 0.08 } },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 15 },
    show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
  };

  return (
    // ✅ w-full, no max-width, no horizontal padding here
    <section className="w-full bg-[#f8fafc] py-16">
      {/* ✅ Inner padding only — matches Figma edge-to-edge bg with content padding */}
      <div className="px-12">

        <div className="mb-12 text-left">
          <div className="inline-block px-2.5 py-0.5 rounded-full bg-[#E0F2FE] mb-4">
            <span className="text-[#3b82f6] text-[10px] font-extrabold uppercase tracking-widest">
              Audit & Sécurité
            </span>
          </div>
          <h2 className="text-[#0f172a] text-[38px] font-[900] leading-tight mb-4 tracking-tight">
            Types de pentests
          </h2>
          <p className="text-[#64748b] text-[14.5px] leading-relaxed max-w-[550px] font-medium opacity-90">
            Des audits de sécurité approfondis basés sur des méthodologies reconnues pour protéger votre infrastructure et vos applications contre les menaces modernes.
          </p>
        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5"
        >
          {pentestData.map((item, idx) => (
            <motion.div
              key={idx}
              variants={itemVariants}
              whileHover={{
                y: -6,
                borderColor: '#3b82f6',
                boxShadow: "0 12px 30px -10px rgba(59, 130, 246, 0.15)"
              }}
              className="group p-7 bg-white rounded-2xl border border-slate-100 shadow-sm transition-all duration-300 cursor-pointer"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-[#E0F2FE] text-[#3b82f6] rounded-lg mb-5 group-hover:bg-[#3b82f6] group-hover:text-white transition-all duration-300 ease-in-out">
                {item.icon}
              </div>
              <h3 className="text-[#0f172a] text-[17px] font-black mb-3 group-hover:text-[#3b82f6] transition-colors duration-300">
                {item.title}
              </h3>
              <p className="text-slate-500 text-[13px] leading-relaxed font-medium">
                {item.description}
              </p>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default PentestTypes;